var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoChangePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.4 21h-1.1v-3.2c0-3.2-2.6-5.8-5.8-5.8h-1c-3.2 0-5.8 2.6-5.8 5.8V21h-1.1c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h14.7c.6 0 1-.4 1-1V22c0-.6-.4-1-1-1Zm-11.6-3.2c0-2.1 1.7-3.8 3.8-3.8h1c2.1 0 3.8 1.7 3.8 3.8V21h-8.5v-3.2ZM30.4 34H17.7V23h12.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 25c-1.1 0-2 .8-2 2s.4 1.4 1.1 1.7v2.2c0 .6.4 1 1 1s1-.4 1-1v-2.2c.6-.3 1-1 1-1.7 0-1.2-1-2-2-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChangePassword);
export default __webpack_public_path__ + "static/media/IcoChangePassword.ec1c47b3108493b8ce47387a038e3e6d.svg";
export { ForwardRef as ReactComponent };